<app-header></app-header>
<div id="theme_id" class="theme-red bg-account-pages">

<section class="height-100vh">
    <div class="display-table">
        <div class="display-table-cell">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-5">
                        <div class="card account-card">
                            <div class="card-body">
                                <div class="text-center mt-3">
                                  <a href="/" class="navbar-brand logo text-uppercase">
									<img style="width:180px; height: auto;"  src="assets/images/IncluTec.png" alt="IncluTec Logo">
								  </a>
                                    <p class="text-muted">Registre una nueva cuenta</p>
                                </div>
                                <div class="p-3">
                                    <form>
                                        <div class="form-group">
                                            <label for="firstname">Primer Nombre</label>
                                            <input type="text" class="form-control"  id="firstname" name="firstname" [(ngModel)]="firstname" placeholder="Ingrese nombre">
                                        </div>
										<div class="form-group">                                    
											<label for="lastname">Primer Apellido</label>
                                            <input type="text" class="form-control" id="lastname" name="lastname" [(ngModel)]="lastname" placeholder="Ingrese apellido">
                                        </div>

                                        <div class="form-group">
                                            <label for="email">Email</label>
                                            <input type="email" class="form-control" id="email" name="email" [(ngModel)]="email" placeholder="Ingrese email">
                                        </div>

                                        <div class="form-group">
                                            <label for="userpassword">Password</label>
                                            <input type="password" class="form-control" id="userpassword" name="userpassword" [(ngModel)]="userpassword" placeholder="Ingrese password">
                                        </div>
<!--
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" id="customControlInline">
                                            <label class="custom-control-label" for="customControlInline">Recordarme</label>
                                        </div>
-->
                                        <div class="mt-3">
                                            <button 
                                                type="button" 
                                                class="btn btn-custom btn-block" 
                                                [disabled]="isSubmitting"
                                                (click)="registro()">
                                                <span *ngIf="!isSubmitting">Registrarse</span>
                                                <span *ngIf="isSubmitting">
                                                    <i class="fa fa-spinner fa-spin"></i> Procesando...
                                                </span>
                                            </button>
                                        </div>

                                        <div class="mt-4 mb-0 text-center">
                                            <!-- Referencia al login ocultada temporalmente - no se usará por ahora -->
                                            <!--
                                            <p class="mb-0">¿Ya tiene una cuenta? <a href="/login" class="text-danger">Login</a></p>
                                            -->
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</div>